import type { CellStyle } from '@maxgraph/core';

export const DEFAULT_VERTEX_STYLE: CellStyle = {
  fillColor: '#FFFFFF',
  strokeColor: '#1E40AF',
  fontColor: '#1F2937',
  fontSize: 12,
  rounded: true,
  whiteSpace: 'wrap',
  overflow: 'hidden',
  align: 'center',
  verticalAlign: 'middle',
};

export const DEFAULT_EDGE_STYLE: CellStyle = {
  strokeColor: '#2563EB',
  strokeWidth: 1.5,
  endArrow: 'block',
  endSize: 8,
  // Straight-edge invariant baseline. Layout/runtime normalization may reapply
  // these keys when legacy geometry or style overrides are encountered.
  rounded: true,
  curved: true,
  edgeStyle: 'none',
  labelBackgroundColor: '#FFFFFF',
  fontSize: 11,
  fontColor: '#374151',
};

export const DIMENSIONS = {
  materialNode: { width: 80, height: 80 },
  operationNode: { width: 100, height: 28 },
} as const;

export const GRID_BACKGROUND_URL = '/assets/wires-grid.gif';
